var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.barOnTop ? 'top' : '',attrs:{"id":"app"}},[(_vm.showSearch)?_c('SearchBar'):_vm._e(),_c('TaskBar'),(_vm.user)?_c('MediaGrid',{attrs:{"uid":_vm.user.uid}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }